export default "__VITE_ASSET__CUqik1qV__"